import { useState } from "react";
import DocxViewer from "./DocxViewer";
import { TERMS_DOCX } from "../utils/termsConfig";
import "./PersonalInformation.css";

const TABS = [
  {
    label: "소비자 개인정보 처리방침",
    file: TERMS_DOCX.privacy.file,
  },
  {
    label: "가맹점 개인정보 처리방침",
    file: TERMS_DOCX.seller.file,
  },
];

function PersonalInformation() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="pi-page">
      <div className="pi-tab-bar">
        {TABS.map((tab, index) => (
          <button
            key={index}
            className={`pi-tab-btn${activeTab === index ? " active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="pi-content">
        {TABS.map((tab, index) => (
          <div
            key={index}
            className={`pi-docx-viewer${activeTab === index ? " visible" : ""}`}
          >
            {activeTab === index && <DocxViewer fileName={tab.file} />}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PersonalInformation;